import get from 'lodash/get';
import moment from 'moment';
import { shortYearDateFormat } from './formats';

export const getNumberLabel = (channel, type) => {
  if (channel === 'digital' || type === 'season') {
    return 'Episode #';
  }

  return 'Source #';
};

export const getYouTubeVideoIdFromURL = (url) => {
  if (!url || !url.length) {
    return null;
  }

  const match = url.match(
    /^(?:https?:)?(?:\/\/)?(?:www\.)?(?:youtu)(?:\.be\/|be\.com\/)(?:watch\?v=|embed\/|)(.*)/,
  );
  if (match && match.length) {
    return match[1];
  }

  return null;
};

export const getLastEdit = (props) => ({
  at: get(props, 'updated.at', get(props, 'created.at')),
  by: get(props, 'updated.by', get(props, 'created.by')),
  byFullName: get(
    props,
    'cache.updated.by.name',
    get(props, 'cache.created.by.name'),
  ),
});

export const denormalizeCached = (obj, valueKey) =>
  Object.keys(obj).map((key) => ({ [valueKey]: key, ...obj[key] }));

export const addFullName = (object) => ({
  ...object,
  name: `${object.firstName} ${object.lastName}`,
});

export const isFilterSet = (filter) =>
  (Array.isArray(filter)
    ? Boolean(filter.length)
    : filter !== undefined && filter !== null);

export const getLastEditText = (entity) => {
  const name = `${entity.updatedBy.firstName} ${entity.updatedBy.lastName}`;
  const date = moment.utc(entity.updatedAt).format(shortYearDateFormat);

  return `${date} by ${name}`;
};

export const getPlacementQualityLabel = (quality) => {
  const qualityMap = {
    'standard': 'Standard',
    'premium': 'Premium',
    'prominent': 'Prominent',
    'ungraded': 'Ungraded',
    null: 'MSFT X',
  };

  return qualityMap[quality] || quality;
};
